import React from 'react';
import { FiChevronRight } from 'react-icons/fi';
import styled from 'styled-components';

import {
  Profile,
  ProfileList,
  Description,
  Icon,
  Text
} from './Elements';
import { Layout } from './Layout';
import { Skills } from './Skills';

const Title = styled.h1`
  cursor: default;
  font-family: var(--title-font);
  text-transform: uppercase;
`;

const CardTitle = styled.div`
  display: inline-block;
  background-color: var(--secondary-color);
  padding: 5px 10px;
  margin-bottom: 5px;
`;

const Paragraph = styled.p`
  margin: 20px 0;
`;

export const About = () => {
  return (
    <Layout>
      <div>
        <title>About me</title>
        <Title>
          Hi, my name is <CardTitle>Mikel Loidi</CardTitle>
        </Title>
        <Paragraph>
          I am a Software Engineer currently located in Murrieta, California,
          working as an Application Developer at Capsim Management
          Simulations, where I focus on EdTech and building scalable,
          data-driven simulations. In my free time, I am constantly
          experimenting with new projects, pushing my skills to adapt the
          latest web tech to build new web designs.
        </Paragraph>
        <Paragraph>
          I am passionate about development and design. My day-to-day stack
          centers on Vue.js, Node.js and Java, with HTML5, CSS3/SCSS and SQL
          rounding things out. I also keep JavaScript and React in my toolkit
          and enjoy digging into new tools and techniques.
        </Paragraph>
        <Paragraph>
          Who doesn't love a good challenge? Whether it's a new industry or
          new tools and techniques, I am always fascinated by being able to
          solve the puzzle to satisfy the user's needs.
        </Paragraph>
        <Profile>
          <h2>Profile</h2>
          <Paragraph>
            Software Engineer with over 20 years of experience structuring,
            developing and implementing applications, from EdTech simulations
            to enterprise systems for government, healthcare and banking.
            Able to complete projects efficiently and satisfy clients.
          </Paragraph>
          <ProfileList>
            <Description>
              <Icon>
                <FiChevronRight aria-hidden='true' focusable='false' />
              </Icon>
              <Text>Advanced programming and design skills</Text>
            </Description>
            <Description>
              <Icon>
                <FiChevronRight aria-hidden='true' focusable='false' />
              </Icon>
              <Text>Excellent problem solving skills</Text>
            </Description>
            <Description>
              <Icon>
                <FiChevronRight aria-hidden='true' focusable='false' />
              </Icon>
              <Text>Strong collaborative skills</Text>
            </Description>
            <Description>
              <Icon>
                <FiChevronRight aria-hidden='true' focusable='false' />
              </Icon>
              <Text>Requirements gathering &amp; functional analysis</Text>
            </Description>
            <Description>
              <Icon>
                <FiChevronRight aria-hidden='true' focusable='false' />
              </Icon>
              <Text>Project Management</Text>
            </Description>
            <Description>
              <Icon>
                <FiChevronRight aria-hidden='true' focusable='false' />
              </Icon>
              <Text>Team Leadership</Text>
            </Description>
            <Description>
              <Icon>
                <FiChevronRight aria-hidden='true' focusable='false' />
              </Icon>
              <Text>Risk Analysis</Text>
            </Description>
            <Description>
              <Icon>
                <FiChevronRight aria-hidden='true' focusable='false' />
              </Icon>
              <Text>Multilingual Communication (Spaninsh &amp; English)</Text>
            </Description>
          </ProfileList>
        </Profile>
        <Skills />
        <Profile>
          <h2>Let's talk</h2>
          <Paragraph>
            I'd love to hear from you! Whether you want to know more about my
            work, talk about an opportunity, or just say hi, connect with me
            on{' '}
            <a
              href='https://www.linkedin.com/in/mikel-loidi-ardanaz/'
              target='_blank'
              rel='noopener noreferrer'
            >
              LinkedIn
            </a>{' '}
            or drop me an{' '}
            <a href='mailto:mikel@mloidi.com'>email</a> — I'm always happy to
            chat.
          </Paragraph>
        </Profile>
      </div>
    </Layout>
  );
};
